import React from 'react';
import { SelectAllContainer, SelectAllButton as StyledSelectAllButton } from '../Select.styles';

interface SelectAllButtonProps {
  isAllSelected: boolean;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const SelectAllButton: React.FC<SelectAllButtonProps> = ({
  isAllSelected,
  onSelectAll,
  onDeselectAll
}) => {
  const handleClick = () => {
    if (isAllSelected) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  };

  return (
    <SelectAllContainer>
      <StyledSelectAllButton
        type="button"
        onClick={handleClick}
      >
        {isAllSelected ? "Deseleccionar todo" : "Seleccionar todo"}
      </StyledSelectAllButton>
    </SelectAllContainer>
  );
};
